class SidebarCtrl {
    constructor($scope, $q, $interval, $window) {
        var self = this;

        self.state = {
            isExpanded: false,
            offset: 296
        };

        self.data = {};
        self.sidebar = {};

        self.changeExpended = function () {
            self.state.isExpanded = !self.state.isExpanded;
        };

        self.fixOffset = function(){
            self.state.offset = $('.main-wrapper').offset().top;
        };

        let getJQueryForm = function () {
            return $('form#recruitment');
        };

        self.finishLater = function()
        {
            let form = getJQueryForm();
            form.attr('novalidate', true);
            form.find('.continue-recruitment').val(1);

            form.submit();
        };

        self.advisorFinish = function (lastStepUrl)
        {
            let form = getJQueryForm();
            form.attr('action', lastStepUrl);

            self.autoSave().then(() => {
                $window.location.href = lastStepUrl;
            });
        };

        self.advisorContinue = function ()
        {
            self.autoSave().then(() => {
                $window.location.href = getJQueryForm().attr('action');
            });
        };

        self.autoSave = function() {
            clearTimeout(self.autoSaveTimeout);
            return $q((resolve) => {
                let form = getJQueryForm()[0];
                let formData = new FormData(form);
                formData.set('continueRecruitment', 1);

                let xhr = new XMLHttpRequest();
                xhr.open('POST', form.action, true);
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                xhr.send(formData);

                resolve();
            });
        };
        self.autoSaveWithTimeout = function() {
            self.autoSaveTimeout = setTimeout(()=>{
                self.autoSave();
            }, 2000);
        };


        jQuery(() => {
            self.fixOffset();
        });
    }
    $onInit() {
        let self = this;
        $('input').on("blur", self.autoSaveWithTimeout);
    }
}

SidebarCtrl.$inject = ['$scope', '$q', '$interval', '$window'];

export default SidebarCtrl;
